import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { ProductFeaturesDirective } from './product-features.directive';
export var ProductFeaturesComponentNgModule = module(baseModuleId + ".product-features", [])
    .directive('productFeatures', ProductFeaturesDirective);
